import ConfigWidgetLabel from 'scoreboard/dashboards/widgets/config-widget-label'
import Dataset from 'scoreboard/datasets/model/dataset'

/**
 * View for editing a dataset table widget's label
 */
const ConfigDatasetTableLabel = ConfigWidgetLabel.extend({
	dialogTitle: 'dashboards.setTitle',

	_getModelLabel: function () {
		return this.model.properties.get('label')
	},

	_setModelLabel: function (label) {
		this.model.properties.set('label', label)
	},

	_getSuggestion: function () {
		let props = this.model.properties

		let dataset = new Dataset(this.model.data.datasets(props.get('datasetId')))
		return dataset.combinedFieldsById[this.model.table.get('fieldId')].label
	}
})

export default ConfigDatasetTableLabel

ConfigDatasetTableLabel.__filename__ = 'dashboards/widgets/dataset-table/config-dataset-table-label.js'
